export const mindWanderingItems = [
  {
    id: 'mindwandering_1',
    text: {
      de: 'Wie häufig ist es zu einem Abschweifen der Gedanken gekommen?'
    }
  },
  {
    id: 'mindwandering_2',
    text: {
      de: 'Wie häufig ist es zu einem unbeabsichtigten Abschweifen der Gedanken gekommen?'
    }
  },
  {
    id: 'mindwandering_3',
    text: {
      de: 'Wie häufig ist es zu einem beabsichtigten Abschweifen der Gedanken gekommen?'
    }
  },
  ]